import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { CardType } from 'src/app/enums/card-type';
import { Project } from 'src/app/interfaces/project';
import { ProjectService } from 'src/app/services/project.service';
import { SettingsService } from 'src/app/services/settings.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CardComponent } from '../cards/card/card.component';
import { NgIf, NgFor } from '@angular/common';

@Component({
  selector: 'app-project-suggestion-slider',
  templateUrl: './project-suggestion-slider.component.html',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    CardComponent,
    NgxSkeletonLoaderModule,
    TranslateModule,
  ],
})
export class ProjectSuggestionSliderComponent implements OnInit {
  @Input() title: string;
  @Input() excludedProject: Project;

  public projects: Project[];
  public projectsLoaded = false;
  isEnabled: boolean;

  private MAX_DISPLAYED_PROJECTS = 10;

  CardType = CardType;

  constructor(
    private projectService: ProjectService,
    private settingsService: SettingsService
  ) {
    this.checkSuggestions();
    this.settingsService.settingsChanged$.subscribe(() => {
      this.checkSuggestions();
    });
  }

  ngOnInit() {
    this.loadProjectSuggestions();
    this.projectService.projectSuggestionDismissed$.subscribe((p) =>
      this.dismissProject(p)
    );
  }

  checkSuggestions() {
    this.settingsService.getSuggestionsEnabled().then((value) => {
      this.isEnabled = value === null ? true : value;
    });
  }

  private async loadProjectSuggestions() {
    let urlParams = new HttpParams();
    urlParams = urlParams.set('limit', this.MAX_DISPLAYED_PROJECTS.toString());

    try {
      this.projects = await this.projectService.getSuggestedProjects(urlParams);
      this.projectsLoaded = true;
      if (this.excludedProject) this.dismissProject(this.excludedProject);
    } catch (error) {
      // ignore
    }
  }

  public dismissProject(project: Project) {
    this.projects = this.projects.filter((p) => p.id != project.id);
  }
}
